export default function TrustSignals() {
  return (
    <section className="py-16 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-50 rounded-full mx-auto mb-4">
              <i className="ri-map-pin-user-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Focused on El Paso Since 2024
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              We exclusively serve El Paso and understand the unique needs of our desert community, from climate challenges to local building codes and neighborhood characteristics.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-50 rounded-full mx-auto mb-4">
              <i className="ri-sun-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Tips for El Paso Climates &amp; Soils
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              Our contractors specialize in solutions designed for extreme heat, caliche soil, water conservation, and the unique environmental factors that impact El Paso homes.
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-teal-50 rounded-full mx-auto mb-4">
              <i className="ri-file-list-3-line text-3xl text-teal-600"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-2">
              Understanding El Paso Building Codes
            </h3>
            <p className="text-sm text-gray-600 leading-relaxed">
              All featured contractors maintain proper licensing, stay current with local building codes, and ensure full compliance with El Paso's permit and inspection requirements.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
